
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import BrandCapitalPage from '../pages/brand-capital/page';
import BCIPage from '../pages/bci/page';
import ServiziPage from '../pages/servizi/page';
import PerchéValorizzarePage from '../pages/perche-valorizzare/page';
import { CaseStudyPage } from '../pages/case-study/page';
import { RisorsePage } from '../pages/risorse/page';
import FAQPage from '../pages/faq/page';
import ContattiPage from '../pages/contatti/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/brand-capital',
    element: <BrandCapitalPage />
  },
  {
    path: '/bci',
    element: <BCIPage />
  },
  {
    path: '/servizi',
    element: <ServiziPage />
  },
  {
    path: '/perche-valorizzare',
    element: <PerchéValorizzarePage />
  },
  {
    path: '/case-study',
    element: <CaseStudyPage />
  },
  {
    path: '/risorse',
    element: <RisorsePage />
  },
  {
    path: '/faq',
    element: <FAQPage />
  },
  {
    path: '/contatti',
    element: <ContattiPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
